import { Dialog, Layout, Text } from '@loadsmart/miranda-react'

type DeleteLocationDialogProps = {
  readonly isOpen: boolean
  readonly isLoading: boolean
  readonly onCancel: () => void
  readonly onDelete: () => void
}

export default function DeleteLocationDialog({
  isOpen,
  isLoading,
  onCancel,
  onDelete,
}: DeleteLocationDialogProps) {
  return (
    <Dialog open={isOpen} onClose={onCancel} size="small">
      <Dialog.Header>Remove location</Dialog.Header>
      <Dialog.Body>
        <Layout.Stack>
          <Text variant="body-md" color="color-text-primary">
            Client won't be able to see this location anymore.
          </Text>
        </Layout.Stack>
      </Dialog.Body>
      <Dialog.Actions>
        <Dialog.ActionTertiary onClick={onCancel}>Cancel</Dialog.ActionTertiary>
        <Dialog.ActionPrimary onClick={onDelete} variant="danger" loading={isLoading}>
          Confirm delete
        </Dialog.ActionPrimary>
      </Dialog.Actions>
    </Dialog>
  )
}
